<template>
	<div class="inner-page edit-team">
    <AppHead title="Manage Distributor" />

    <PageHeader 
      title="Manage Distributor"
      desc="Edit the details of this distributor"
      :hasButton="false"
      :showHelper="false"
      :hr="true"
      />

    <InputGroup
      title="Distributor Details"
      >

      <ValidationErrors />
      
      <InputText
        label="Distributor Name"
        type="text"
        v-model="form.name"
        autocomplete="disabled"
        :disabled="$page.props.user.user_type == 'team_admin'"
        />

    </InputGroup>

    <InputGroup
      title="Distributor Enquiry Forms"
      :skipWhiteBox="true"
      >

      <EnquiryFormUploadControls
        :team="thisTeam.id"
        designation="team-enquiry-form"
        @done="refreshFiles"
        />

      <TableDocuments
        title="Distributor Enquiry Forms"
        v-if="['admin', 'team_admin'].includes($page.props.user.user_type) && enquiryForms.length > 0"
        desc="These enquiry forms will be shown to users who are part of this distributor when they create a new case."
        noDocsMessage="There are no enquiry forms available"
        :files="enquiryForms"
        :canDelete="true"
        :showProcessing="true"
        :canDownload="true"
        />

    </InputGroup>

    <InputGroup
      title=""
      desc=""
      :skipWhiteBox="true"
      :noLine="true"
      >
      <Button
        label="Update"
        color="green"
        size="regular"
        icon="plus" 
        @click="submit"
        />
    </InputGroup>

	</div>
</template>

<script>
import AppHead from "@/Components/AppHead"
import AppLayout from "@/Layouts/AppLayout.vue"
import PageHeader from "@/Components/PageHeader"
import InputGroup from "@/Components/InputGroup"
import InputText from "@/Components/InputText"
import InputFancyRadio from "@/Components/InputFancyRadio"
import Button from "@/Components/Button"
import ValidationErrors from "@/Components/ValidationErrors"
import EnquiryFormUploadControls from "@/Components/Admin/EnquiryFormUploadControls"
import TableDocuments from "@/Components/TableDocuments"

export default {
	props: [
		'thisTeam',
    'enquiryForms'
	],
	components: {
    AppHead,
    PageHeader,
    InputGroup,
    InputText,
    InputFancyRadio,
    ValidationErrors,
    Button,
    EnquiryFormUploadControls,
    TableDocuments
	},
	layout: AppLayout,
  data: () => {
    return {
      form: {
        name: null
      }
    }
  },
  methods: {
    submit(){
      let count = 0
      for(let field in this.form){
        let thisField = this.form[field]
        if(thisField == null || thisField == ''){
          break
        }
        count++
      }

      if(Object.keys(this.form).length == count){
        this.$inertia.post(`/admin/team/${this.thisTeam.id}/update`, {
          name: this.form.name,
        })
      }else{
        alert(`Please complete all fields`)
      }
    },
    refreshFiles(){
      this.$inertia.reload()
    }
  },
	mounted(){
    // console.log('enquiryForms', this.enquiryForms)
		if(this.thisTeam){
			this.form.name = this.thisTeam.name
		}
	}
};
</script>

<style lang="sass" scoped>

// .edit-team

</style>